import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import OverlayTrigger from "../OverlayTrigger";
import { overlayDirections } from "../../styles/mixins/overlays";
var TriggerContainer = styled.span.withConfig({
  displayName: "TooltipTrigger__TriggerContainer",
  componentId: "i3pxhc-0"
})(["display:inline-flex;"]);

var TooltipTrigger =
/*#__PURE__*/
function (_Component) {
  _inherits(TooltipTrigger, _Component);

  function TooltipTrigger(props) {
    var _this;

    _classCallCheck(this, TooltipTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TooltipTrigger).call(this, props));

    _this.onTouch = function () {
      if (_this.timeoutId) {
        _this.onHide();
      } else {
        _this.props.onShow();

        _this.timeoutId = window.setTimeout(_this.onHide, _this.props.timeout);
      }
    };

    _this.onHide = function () {
      _this.props.onHide();

      if (_this.timeoutId) {
        window.clearTimeout(_this.timeoutId);
        _this.timeoutId = undefined;
      }
    };

    _this.triggerRef = _this.props.withPortal ? React.createRef() : null;
    return _this;
  }

  _createClass(TooltipTrigger, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          timeout = _this$props.timeout,
          onShow = _this$props.onShow,
          onHide = _this$props.onHide,
          isTouch = _this$props.isTouch,
          props = _objectWithoutProperties(_this$props, ["children", "timeout", "onShow", "onHide", "isTouch"]);

      var onTrigger = !isTouch ? onShow : undefined;
      var offTrigger = !isTouch ? onHide : undefined;
      return React.createElement(OverlayTrigger, Object.assign({}, props, {
        ref: this.triggerRef,
        closeOverlay: offTrigger
      }), React.createElement(TriggerContainer, {
        role: "button",
        onClick: isTouch ? this.onTouch : undefined,
        onMouseOver: onTrigger,
        onMouseOut: offTrigger,
        onFocus: onTrigger,
        onBlur: offTrigger
      }, children));
    }
  }]);

  return TooltipTrigger;
}(Component); // export placement options


TooltipTrigger.propTypes = {
  /** Where the overlay will appear in relation to its target */
  placement: PropTypes.oneOf(['top', 'topRight', 'topLeft', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),

  /** Can accept any JSX, meant for a Tooltip component */
  overlay: PropTypes.node,

  /** Can accept an JSX, meant for a button or icon that triggers the tooltip */
  children: PropTypes.node,

  /** Number of milliseconds that the tooltip remains visible for when triggered on touch devices */
  timeout: PropTypes.number,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  isTouch: PropTypes.bool,
  withPortal: PropTypes.bool
};
TooltipTrigger.defaultProps = {
  timeout: 2000,
  onShow: function onShow() {},
  onHide: function onHide() {}
};
export { TooltipTrigger as default };
Object.keys(overlayDirections).forEach(function (placement) {
  TooltipTrigger[placement] = placement;
});